module.exports = __webpack_public_path__ + "Bild_4.9f9e00ee96575af96272f434d855f582.png";